<template>
  <v-card
    class="redeemed-item-card"
    elevation="0"
  >
    <v-row>
      <v-col
        cols="12"
        md="7"
      >
        <redeemed-item-details :item="item" />
      </v-col>
      <v-col
        cols="12"
        md="5"
        class="details"
      >
        <v-card-text>
          <item-successful
            v-if="item.isSuccessful"
            :item="item"
            :is-payment-reward-type="isPaymentRewardType"
            @resend-reward="$emit('resend-reward', item)"
          />
          <item-unsuccessful
            v-if="item.isUnsuccessful"
            :item="item"
            :is-payment-reward-type="isPaymentRewardType"
          />
          <redemption-history-need-help
            v-if="chatBotEnabled"
            :is-payment-reward-type="isPaymentRewardType"
            :item="item"
          />
          <order-reference-detail
            class="mt-6"
            :reference-id="item.referenceLineItemId"
          />
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import ItemSuccessful from '@/components/history/ItemSuccessful'
import ItemUnsuccessful from '@/components/history/ItemUnsuccessful'
import OrderReferenceDetail from '@/components/history/OrderReferenceDetail'
import RedeemedItemDetails from '@/components/history/RedeemedItemDetails'
import { RedeemedItem } from '@/store/classes/redeemed-item'
import RedemptionHistoryNeedHelp from '@/components/history/RedemptionHistoryNeedHelp'
import { SVP_ADA_CHATBOT_ENABLED } from '@/plugins/split/ActiveSplits'
import { PAYMENT_REWARD_TYPES } from '@/components/shared/item/reward-type-constants'

export default {
  name: 'RedeemedItem',
  components: {
    RedemptionHistoryNeedHelp,
    RedeemedItemDetails,
    ItemSuccessful,
    ItemUnsuccessful,
    OrderReferenceDetail
  },
  props: {
    item: {
      type: RedeemedItem,
      required: true
    }
  },
  computed: {
    chatBotEnabled () {
      return this.$isSplitEnabled(SVP_ADA_CHATBOT_ENABLED)
    },
    isPaymentRewardType () {
      return PAYMENT_REWARD_TYPES.includes(this.item.rewardType)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/scss/variables';
.redeemed-item-card {
  margin-bottom: map-get($spacers, 4);
  border: solid 1px map-get($grey, 'lighten-2');
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  p {
    margin-bottom: 0.25rem;
  }
}
.details {
  background-color: map-get($grey, 'lighten-4');
}
</style>
